import React, { Component } from 'react'
import Icon from 'components/icon/icon'

class Checkbox extends Component {
	render() {
		const {
			onChange,
			isChecked,
			ignoreLabel
		} = this.props

		let className = 'checkbox'

		// If it's not being wrapped by a <label>, expand the clickable area with a :before
		if(ignoreLabel){
			className += ' expand-clickable-area'
		}

		// Removing the key from the input makes it fail to re-render sometimes...
		return (
			<span className={className} onClick={e => {
				e.stopPropagation()
				e.preventDefault()
				onChange(!isChecked)
			}}>
				<input 
					ref={ref => this.ref = ref} 
					onChange={_ => {onChange(!isChecked)}}
					onClick={e => e.stopPropagation()}
					checked={isChecked} 
					type="checkbox" 
					key={isChecked}
				/>
				<em>
					<Icon name="check" />
				</em>
			</span>
		);
	}
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/input/checkbox.jsx